export const Color = Object.freeze({
	base: '#17a3ea',
	transparent: 'transparent'
});